// ProfileSearch.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ProfileSearch() {
    const navigate = useNavigate();
    const [habboName, setHabboName] = useState("");
    const [hotel, setHotel] = useState("COM");

    const handleSearch = (e) => {
        e.preventDefault();
        if (habboName.trim()) {
            navigate(`/player/${hotel}/${habboName.trim()}`);
        }
    };

    return (
        <div>
            <div className="flex gap-2 mb-3">
                <input
                    type="text"
                    value={habboName}
                    onChange={(e) => setHabboName(e.target.value)}
                    placeholder="Habbo Name"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm focus:outline-none focus:border-maroon"
                />
                <select
                    value={hotel}
                    onChange={(e) => setHotel(e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded text-sm uppercase focus:outline-none focus:border-maroon"
                >
                    <option value="COM">COM</option>
                    <option value="ES">ES</option>
                    <option value="BR">BR</option>
                </select>
            </div>

            <button
                onClick={handleSearch}
                className="w-full bg-green-600 text-white px-6 py-2 text-sm uppercase tracking-wider transition-opacity hover:opacity-90 mb-3"
                style={{ boxShadow: "0 3px 0 0 rgba(0, 0, 0, 0.3)" }}
            >
                Search
            </button>
        </div>
    );
}
